import { HistoryEntry } from 'src/app/services/store-history/store-history.service';

/** What the Changes tab can be showing. Exactly one at a time, resolved by the sheet. */
export type ChangesState = 'loading' | 'error' | 'no-snapshot' | 'empty' | 'ready';

export interface ChangesSection {
  /** `undefined` on the Unsaved section, which has no snapshot behind it. */
  snapshotAt?: Date;
  tier: 'draft' | 'saved';
  entries: HistoryEntry[];
}

/**
 * Whether an entry can be acted on at all.
 *
 * System entries are context, not commands — a webhook's write is not the merchant's to take back
 * one row at a time. Blocked, undone and sealed entries have nothing left to reverse.
 */
export const isActionable = (entry: HistoryEntry): boolean =>
  entry.actor.type !== 'system' && !entry.blocked && !entry.undone && !entry.superseded;
